import { apiClientConfig } from "@/utils/api-utils"
import { TaskApi, TaskDesignationEnum } from "@vitable/asclepius-api-client-ts"

const state = () => ({
  totalUnassignedCareTeamTasksCount: undefined,
  totalAssignedTasksCount: undefined,
  showTasksBadgeIn: false
})

const getters = {
  showTasksBadgeIn: (state) => {
    return state.showTasksBadgeIn
  }
}

const actions = {
  /**
   * Total number of Care Team tasks that are unassigned.
   */
  async getUnassignedCareTeamTasksCount({ commit }) {
    try {
      const taskApi = new TaskApi(apiClientConfig())

      const data = (
        await taskApi.listTasks({
          limit: 1,
          designation: TaskDesignationEnum.CareTeam,
          withoutAssigneeIn: true,
          completedIn: false,
          deletedIn: false
        })
      ).data

      commit("setTotalUnassignedCareTeamTasksCount", {
        count: data.count
      })
    } catch (e) {
      console.error(`getUnassignedCareTeamTasksCount(…) failed – ${e}`)
    }
  },

  /**
   * Total number of tasks assigned to logged-in user.
   */
  async getAssignedTasksCount({ commit, rootGetters }) {
    const appUserId = rootGetters["me/userId"]
    const appUserIsClinicalAdminIn = rootGetters["me/isClinicalAdmin"]
    try {
      const taskApi = new TaskApi(apiClientConfig())
      const designation = appUserIsClinicalAdminIn ? TaskDesignationEnum.CareTeam : TaskDesignationEnum.Provider

      const data = (
        await taskApi.listTasks({
          limit: 1,
          designation: designation,
          assigneeId: appUserId,
          completedIn: false,
          deletedIn: false
        })
      ).data

      commit("setTotalAssignedTasksCount", {
        count: data.count
      })
    } catch (e) {
      console.error(`getAssignedTasksCount(…) failed – ${e}`)
    }
  },

  async checkShowTasksBadgeIn({ commit, state, rootGetters }) {
    if (rootGetters["me/isClinicalAdmin"]) {
      commit("setShowTasksBadgeIn", {
        show:
          (state.totalUnassignedCareTeamTasksCount && state.totalUnassignedCareTeamTasksCount > 0) ||
          (state.totalAssignedTasksCount && state.totalAssignedTasksCount > 0)
      })
    } else {
      commit("setShowTasksBadgeIn", {
        show: state.totalAssignedTasksCount && state.totalAssignedTasksCount > 0
      })
    }
  }
}

const mutations = {
  setTotalUnassignedCareTeamTasksCount(state, { count }) {
    state.totalUnassignedCareTeamTasksCount = count
  },
  setTotalAssignedTasksCount(state, { count }) {
    state.totalAssignedTasksCount = count
  },
  setShowTasksBadgeIn(state, { show }) {
    state.showTasksBadgeIn = show
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
